const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO
}